import { OAuthConfirmAction, OAuthLoginToGameAction, OAuthStartAction } from './oauth';
import {
	HTTP_STATUS_BAD_REQUEST,
	HTTP_STATUS_INTERNAL_SERVER_ERROR,
	HTTP_STATUS_NO_CONTENT,
	HTTP_STATUS_OK,
} from '../../../helpers/validation/common';
import { mockedRedirectResponse } from '../mocks';

/**
 * The backend reports the auth result and the provider that produced it back to the
 * login-hub via query parameters, so the mocks do the same.
 */
const startMock = (authResult: string): OAuthStartAction => async (provider: string, route: string) => {
	return Promise.resolve({
		status: HTTP_STATUS_OK,
		redirectUrl: `/?auth_result=${authResult}&auth_provider=${provider}${route}`,
	});
};

const startFailMock: OAuthStartAction = async (provider: string) => {
	return Promise.resolve({
		status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
		errors: [{ code: `be.api.auth.${provider}.login-failed`, message: `${provider} login failed` }],
	});
};

const confirmSuccessMock: OAuthConfirmAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_NO_CONTENT,
		playerId: 123456,
	});
};

const confirmFailMock: OAuthConfirmAction = async (provider: string) => {
	return Promise.resolve({
		status: HTTP_STATUS_BAD_REQUEST,
		errors: [{ code: `be.api.auth.${provider}.confirm-failed`, message: `${provider} confirm failed` }],
	});
};

const loginToGameSuccessMock: OAuthLoginToGameAction = async () => {
	return Promise.resolve({
		...mockedRedirectResponse,
		status: HTTP_STATUS_NO_CONTENT,
	});
};

const loginToGameFailMock: OAuthLoginToGameAction = async (provider: string) => {
	return Promise.resolve({
		status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
		errors: [{ code: `be.api.auth.${provider}.login-to-game-failed`, message: `${provider} login to game failed` }],
	});
};

export const oauthStartMocks: {
	playerFoundMock: OAuthStartAction;
	playerNotFoundMock: OAuthStartAction;
	playerFoundDirectPlayMock: OAuthStartAction;
	fail: OAuthStartAction;
} = {
	playerFoundMock: startMock('player_found'),
	playerNotFoundMock: startMock('player_not_found'),
	playerFoundDirectPlayMock: startMock('player_found_direct_play'),
	fail: startFailMock,
};

export const oauthConfirmMocks: {
	success: OAuthConfirmAction;
	fail: OAuthConfirmAction;
} = {
	success: confirmSuccessMock,
	fail: confirmFailMock,
};

export const oauthLoginToGameMocks: {
	success: OAuthLoginToGameAction;
	fail: OAuthLoginToGameAction;
} = {
	success: loginToGameSuccessMock,
	fail: loginToGameFailMock,
};
